module.exports = __webpack_public_path__ + "static/media/r26.4ae9ce47.png";